<template>
    <div class="questions">
        <div class="questions__top">
            <h1>Вопросы и ответы</h1>
        </div>

        <div v-if="preload"
             class="questions__preload">
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
        </div>

        <div v-else-if="isError || !blocks?.length"
             class="questions__error">
            <InfoBlock description="Неудалось получить данные! Пожалуйста, попробуйте позже." />
        </div>

        <div v-else
             class="questions__wrapper">
            <div v-for="(block, i) in blocks"
                 :key="i"
                 class="questions__content">
                <h3 v-if="block.title"
                    v-html="block.title" />

                <div v-if="block.text"
                     v-html="block.text" />

                <div v-if="block.list"
                     class="questions__content-list">
                    <STCollapse :only-one-active="false">
                        <STCollapseItem v-for="(item, k) of block.list"
                                        :key="k">
                            <template v-slot:header>
                                <span v-html="item.question" />
                            </template>
                            <template v-slot:content>
                                <div v-html="item.answer" />
                            </template>
                        </STCollapseItem>
                    </STCollapse>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import InfoBlock from '@/blocks/InfoBlock/InfoBlock';
import {mapActions} from 'vuex';

export default {
    name: 'Questions',

    components: {
        InfoBlock
    },

    data() {
        return {
            preload: true,  // показываем ли прелоадер
            isError: false, // есть ли ошибка
            blocks : []     // блоки с информацией
        };
    },

    async mounted() {
        await this.fetchAnswers();
    },

    methods: {
        ...mapActions(['getFAQList']),

        async fetchAnswers() {
            this.preload = true;

            try {
                const result = await this.getFAQList();
                this.preload = false;

                if (result?.data?.length) {
                    this.blocks = result.data;
                } else {
                    this.isError = true;
                }
            } catch(error) {
                this.preload = false;
                this.isError = true;
                console.error('Ошибка получения вопросов/ответов:', JSON.stringify(error));
            }
        }
    }
};
</script>

<style lang="scss">
@import "Questions";
</style>
